var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor)?_c('div',[_c('div',{staticClass:"row justify-center"},[(_vm.editor)?_c('Toolbar',{style:(`width: ${_vm.barWidth ? _vm.barWidth : 'calc(100vw - 200px)'};`),attrs:{"editor":_vm.editor}}):_vm._e()],1),_c('div',{staticClass:"row justify-center"},[_c('div',{style:(`
        border: 1px solid grey;
        border-radius: 10px;
        width: ${_vm.borderWidth ? _vm.borderWidth : 'calc(100vw - 190px)'};
        height: 100%;
        padding-left: 30px;
        padding-right: 30px;
      `)},[_c('q-scroll-area',{style:(`height: calc(100vh - 350px); width: ${
          _vm.contentWidth ? _vm.contentWidth : 'calc(100vw - 200px)'
        };`),attrs:{"thumb-style":{
            background: '#162c479c',
            opacity: 1,
            width: '8px',
            height: '8px',
            borderRadius: '20px',
          }}},[(_vm.editor)?_c('editor-content',{staticClass:"editor__content",staticStyle:{"border":"0px"},attrs:{"editor":_vm.editor}}):_vm._e()],1)],1)]),(_vm.editor)?_c('bubble-menu',{attrs:{"editor":_vm.editor,"tippy-options":{ duration: 100 }}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }